import { Reducer } from "redux";

import { MasterReferralSourceResponse } from "../models/api/Patient";
import { MasterReferralSourceDispatchTypes } from "../models/dispatchTypes/Master";
import { MasterReferralSourceActionDispatchTypes } from "../constants/Master";

const initialState: MasterReferralSourceResponse = {
  loading: false,
  response: [],
  error: null,
};

const MasterReferralSourceReducer: Reducer<
  MasterReferralSourceResponse,
  MasterReferralSourceDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterReferralSourceActionDispatchTypes.MASTER_REFERRAL_SOURCE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterReferralSourceActionDispatchTypes.MASTER_REFERRAL_SOURCE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MasterReferralSourceActionDispatchTypes.MASTER_REFERRAL_SOURCE_ERRORS: {
      return initialState;
    }
  }
  return state;
};

export default MasterReferralSourceReducer;
